export default {
  filter: {
    id: 'buyback_refurbisher_listing_filters_modal_title',
    defaultMessage: 'Filter',
  },
  applyFilters: {
    id: 'buyback_refurbisher_listing_apply_filters',
    defaultMessage: 'Apply filters',
  },
}
